import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import axiosConfig from '../../../configs/axios.config'
// Reducer Thunk
export const getCompareCompanySales = createAsyncThunk('CompareCompanySales/todosFetched', async (loadData) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/report/compareCompanySales`, loadData)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }
})

export const getComparePro2 = createAsyncThunk('CompareCompanySales/getComparePro2', async (loadData) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/report/compareCompanySales`, loadData)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }
})

export const getComparePro4 = createAsyncThunk('CompareCompanySales/getComparePro4', async (loadData) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/report/compareCompanySales`, loadData)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }
})
export const getCompareSlp = createAsyncThunk('CompareCompanySales/getCompareSlp', async (loadData) => {
    try {
        let response
        let docList

        response = await axios.create(axiosConfig).post(`api/report/compareCompanySales`, loadData)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }
})

const CompareCompanySalesSlice = createSlice({
    name: 'CompareCompanySales',
    initialState: {
        compareTotal: [],
        comparePro2: [],
        comparePro4: [],
        compareSlp: [],
        rateTotal: 0,
        currentTotal: 0,
        energySourcesTotal: [{ value: 'CurrentTime', name: 'Kỳ này' }, { value: 'LastTime', name: 'Kỳ trước' }],
        Loading: true,
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getCompareCompanySales.pending, (state, action) => {
            state.Loading = true
        })
        builder.addCase(getCompareCompanySales.fulfilled, (state, action) => {
            state.Loading = false
            state.compareTotal = action.payload
            let lastTotal = 0
            let currentTotalTemp = 0
            const r = (action.payload).reduce((res, value) => {
                lastTotal += value.LastTime
                currentTotalTemp += value.CurrentTime
            }, 0)
            let rateTotalTemp = ((currentTotalTemp - lastTotal) / (lastTotal === 0 ? 1 : lastTotal)) * 100
            state.rateTotal = rateTotalTemp
            state.currentTotal = currentTotalTemp
        })
        builder.addCase(getComparePro2.fulfilled, (state, action) => {
            state.Loading = false
            state.comparePro2 = action.payload
        })
        builder.addCase(getComparePro4.fulfilled, (state, action) => {
            state.Loading = false
            state.comparePro4 = action.payload
        })
        builder.addCase(getCompareSlp.fulfilled, (state, action) => {
            state.Loading = false
            state.compareSlp = action.payload
        })
    }
})

// Reducer
const CompareCompanySalesReducer = CompareCompanySalesSlice.reducer

// Selector
export const CompareCompanySalesSelector = (state) => state.CompareCompanySalesReducer
// Action export
export const {
} = CompareCompanySalesSlice.actions

// Export reducer
export default CompareCompanySalesReducer